export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6842.f069b05e.jpg";